"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryConsumer = exports.HistoryContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.HistoryContext = react_1.default.createContext({
    add: null,
    addDebounced: null,
    startBatch: null,
    endBatch: null,
});
exports.HistoryConsumer = exports.HistoryContext.Consumer;
//# sourceMappingURL=HistoryContext.js.map